export default __webpack_public_path__ + "static/media/Helvetica-Light.cff10fda.ttf";